export default {
  isAuthenticated: localStorage.getItem('token')
}